import {NgModule} from '@angular/core';
import {StoreModule} from '@ngrx/store';
// reducers
import {reducer as loadingReducer} from './reducers/loading.reducer';
import {reducer as authReducer} from './reducers/auth.reducer';

@NgModule({
  imports: [
    StoreModule.forRoot({
      loading: loadingReducer,
      auth: authReducer
    })
  ],
})
export class StateModule { }
